import Textfiled from "components/TextField";
import { CircularProgress, MenuItem, TextFieldProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ITextfiled, SelectFieldProps } from "./type";
import { ITextFieldProps } from "components/TextField/types";

const TextFieldMui = styled(Textfiled)<ITextfiled>(({ theme, value, size }) => ({
  "& .MuiInputBase-input.MuiFilledInput-input": {
    paddingBottom: size === "small" ? "4px !important" : "12px  !important",
  },
  "& .MuiFilledInput-input": {
    color:
      value !== null && value !== undefined
        ? `${theme.palette.text.primary} !important`
        : `${theme.palette.text.disabled} !important`,
  },
}));

const SelectField: React.FC<SelectFieldProps & ITextFieldProps & TextFieldProps> = ({
  value,
  items, // [{id:1,value:"dog"}]
  children,
  defaultValue,
  placeholder = "",
  disabled = false,
  loading = false,
  ...props
}) => {
  return (
    <>
      <TextFieldMui
        select
        {...props}
        value={value}
        defaultValue={defaultValue ? defaultValue : placeholder}
        InputProps={{
          startAdornment: loading && <CircularProgress size={14} />,
        }}
        loading={loading}
        disabled={loading || disabled}
      >
        <MenuItem value={placeholder} sx={{ display: "none" }}>
          {placeholder}
        </MenuItem>
        {items &&
          Array.isArray(items) &&
          items.map((i) => (
            <MenuItem value={i.id} key={i.id} sx={{ whiteSpace: "normal" }}>
              {i.value}
            </MenuItem>
          ))}

        {children}
      </TextFieldMui>
    </>
  );
};

export default SelectField;
